export const SET_REFETCH_DRIVE_MANAGEMENT_LIST = "SET_REFETCH_DRIVE_MANAGEMENT_LIST";

export const SET_DRIVE_MANAGEMENT_DRIVES_LIST = "SET_DRIVE_MANAGEMENT_DRIVES_LIST";

export const TOGGLE_DRIVE_MANAGEMENT_LABEL_DRAWER = "TOGGLE_DRIVE_MANAGEMENT_LABEL_DRAWER";

export const SET_DRIVE_MANAGEMENT_LABELS_LIST = "SET_DRIVE_MANAGEMENT_LABELS_LIST";
